"use strict";

/**
 * Represents a cancellation caused by navigating away
 * before the previous transition has fully resolved.
 */
function Cancellation() {}

module.exports = Cancellation;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-router/lib/Cancellation.js
 ** module id = 112
 ** module chunks = 0
 **/